import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';
import { AppProvider } from './context/app';
import { CartProvider } from './context/cart.tsx';
import { SocketIOProvider } from './context/socket';
import './index.css';

createRoot(document.getElementById('root')!).render(
	// <StrictMode>
	<ThemeProvider>
		<AppProvider>
			<CartProvider>
				<SocketIOProvider>
					<App />
				</SocketIOProvider>
			</CartProvider>
		</AppProvider>
	</ThemeProvider>,
	// </StrictMode>,
);
